export default "__VITE_ASSET__UNSJlK6z__"